import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-form-factors-filters',
  templateUrl: './form-factors-filters.component.html',
  styleUrls: ['./form-factors-filters.component.scss']
})
export class FormFactorsFiltersComponent implements OnInit {
  @Output() formFactorsToFilterBy: EventEmitter<string[]> = new EventEmitter();
  selectedFormFactors: string[] = [];
  title: string = "";
  chromebaseLabel: string = "";
  chromeboxLabel: string = "";
  clamshellLabel: string = "";
  convertibleLabel: string = "";
  tabletLabel: string = "";
  chromebookPlusLabel: string = "";

  constructor(private analytics: AnalyticsService, private confSvc: ConfigService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("formFactorsFilterTitle");
    this.chromebaseLabel = this.confSvc.getString("chromebaseFilterLabel");
    this.chromeboxLabel = this.confSvc.getString("chromeboxFilterLabel");
    this.clamshellLabel = this.confSvc.getString("clamshellFilterLabel");
    this.convertibleLabel = this.confSvc.getString("convertibleFilterLabel");
    this.tabletLabel = this.confSvc.getString("tabletFilterLabel");
    this.chromebookPlusLabel = this.confSvc.getString("chromebookPlusFilterLabel");
  }

  formFactorIsSelected(formFactor: string): boolean {
    return this.selectedFormFactors.some(ff => ff === formFactor);
  }

  onFormFactorChange(formFactor: string): void {
    const indexOfFormFactor = this.selectedFormFactors.indexOf(formFactor);
    indexOfFormFactor < 0 ? this.selectedFormFactors.push(formFactor) : this.selectedFormFactors.splice(indexOfFormFactor, 1);
    this.formFactorsToFilterBy.emit(this.selectedFormFactors);
    this.analytics.logCheckboxFilterClick(AnalyticsUtility.filterType.formFactor, formFactor, indexOfFormFactor < 0);
  }

}
